export const COMPANY_NAME = "Core Collective OC LLC";
export const COMPANY_SHORT = "Core Collective OC";
export const COMPANY_INITIALS = "CCO";
export const COMPANY_ADDRESS_FULL = "11 Breakers Ln, Aliso Viejo, California, US 92656-6007";
export const COMPANY_LOCATION = "Aliso Viejo, California";
export const COMPANY_REGION = "Orange County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=11%20Breakers%20Ln%2C%20Aliso%20Viejo%2C%20California%2C%20US%2092656-6007";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Community-oriented profile" },
  { "label": "Region", "value": "Orange County, California" },
  { "label": "Location", "value": "Aliso Viejo, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Core Collective OC LLC" },
  { "label": "Region", "value": "Orange County, California" },
  { "label": "Address", "value": "11 Breakers Ln, Aliso Viejo, California, US 92656-6007" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Community presence", "body": "A public-facing profile rooted in Orange County." },
  { "icon": "✦", "title": "Local connection", "body": "Information for visitors seeking the organization’s location." },
  { "icon": "✿", "title": "Clear information", "body": "A concise directory entry built from confirmed public details." },
  { "icon": "❍", "title": "Visit locally", "body": "Find the Aliso Viejo address and map directions." },
];
